import { render } from "./PastDeliveryDetails.vue?vue&type=template&id=a165fe22&scoped=true"
import script from "./PastDeliveryDetails.vue?vue&type=script&lang=js"
export * from "./PastDeliveryDetails.vue?vue&type=script&lang=js"

import "./PastDeliveryDetails.vue?vue&type=style&index=0&id=a165fe22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a165fe22"]])

export default __exports__